// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#actionmenu-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
#actionmenu-container .menu-option-popup {
  position: absolute;
  right: 40px;
  top: 24px;
  background-color: var(--ffff);
  padding: 5px 10px;
  width: 151px;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  z-index: 999;
}
#actionmenu-container .menu-option-popup-dark {
  position: absolute;
  right: 40px;
  top: 24px;
  background-color: var(--4d6c);
  padding: 5px 10px;
  width: 151px;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/Actionmenu/Actionmenu.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AAEJ;AAAE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AAEJ","sourcesContent":["#actionmenu-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n  .menu-option-popup {\r\n    position: absolute;\r\n    right: 40px;\r\n    top: 24px;\r\n    background-color: var(--ffff);\r\n    padding: 5px 10px;\r\n    width: 151px;\r\n    border: 1px solid var(--dee3);\r\n    border-radius: 8px;\r\n    z-index: 999;\r\n  }\r\n  .menu-option-popup-dark {\r\n    position: absolute;\r\n    right: 40px;\r\n    top: 24px;\r\n    background-color: var(--4d6c);\r\n    padding: 5px 10px;\r\n    width: 151px;\r\n    border: 1px solid var(--dee3);\r\n    border-radius: 8px;\r\n    z-index: 999;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
